/**
 * Generates the identifier that ties the browser pixel copy of an event to the
 * server-side Conversions API copy of the same logical event.
 *
 * Meta collapses a browser/server pair into one conversion only when both the
 * event name and this id match, within a 48 hour window. A single id is
 * therefore minted once per `tracker.log()` call and shared by every
 * destination, rather than generated per tracker.
 */
export function createEventId(): string {
    if (
        typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function'
    ) {
        return crypto.randomUUID();
    }

    // randomUUID requires a secure context. Fall back so deduplication still
    // works on plain-HTTP local development and older browsers.
    const random = Math.random().toString(36).slice(2, 12);
    return `${Date.now().toString(36)}-${random}`;
}
